/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DiscogsSearchArtistsInnerAliasesInner } from './DiscogsSearchArtistsInnerAliasesInner';
import {
    DiscogsSearchArtistsInnerAliasesInnerFromJSON,
    DiscogsSearchArtistsInnerAliasesInnerFromJSONTyped,
    DiscogsSearchArtistsInnerAliasesInnerToJSON,
} from './DiscogsSearchArtistsInnerAliasesInner';
import type { DiscogsSearchArtistsInnerExternalIdsInner } from './DiscogsSearchArtistsInnerExternalIdsInner';
import {
    DiscogsSearchArtistsInnerExternalIdsInnerFromJSON,
    DiscogsSearchArtistsInnerExternalIdsInnerFromJSONTyped,
    DiscogsSearchArtistsInnerExternalIdsInnerToJSON,
} from './DiscogsSearchArtistsInnerExternalIdsInner';

/**
 * 
 * @export
 * @interface DiscogsSearchArtistsInner
 */
export interface DiscogsSearchArtistsInner {
    /**
     * 
     * @type {string}
     * @memberof DiscogsSearchArtistsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DiscogsSearchArtistsInner
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof DiscogsSearchArtistsInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DiscogsSearchArtistsInner
     */
    realName?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DiscogsSearchArtistsInner
     */
    nameVariations?: Array<string>;
    /**
     * 
     * @type {Array<DiscogsSearchArtistsInnerAliasesInner>}
     * @memberof DiscogsSearchArtistsInner
     */
    aliases?: Array<DiscogsSearchArtistsInnerAliasesInner>;
    /**
     * 
     * @type {Array<DiscogsSearchArtistsInnerExternalIdsInner>}
     * @memberof DiscogsSearchArtistsInner
     */
    externalIds?: Array<DiscogsSearchArtistsInnerExternalIdsInner>;
}

/**
 * Check if a given object implements the DiscogsSearchArtistsInner interface.
 */
export function instanceOfDiscogsSearchArtistsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function DiscogsSearchArtistsInnerFromJSON(json: any): DiscogsSearchArtistsInner {
    return DiscogsSearchArtistsInnerFromJSONTyped(json, false);
}

export function DiscogsSearchArtistsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscogsSearchArtistsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'source': json['source'],
        'name': json['name'],
        'realName': !exists(json, 'realName') ? undefined : json['realName'],
        'nameVariations': !exists(json, 'nameVariations') ? undefined : json['nameVariations'],
        'aliases': !exists(json, 'aliases') ? undefined : ((json['aliases'] as Array<any>).map(DiscogsSearchArtistsInnerAliasesInnerFromJSON)),
        'externalIds': !exists(json, 'external_ids') ? undefined : ((json['external_ids'] as Array<any>).map(DiscogsSearchArtistsInnerExternalIdsInnerFromJSON)),
    };
}

export function DiscogsSearchArtistsInnerToJSON(value?: DiscogsSearchArtistsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'source': value.source,
        'name': value.name,
        'realName': value.realName,
        'nameVariations': value.nameVariations,
        'aliases': value.aliases === undefined ? undefined : ((value.aliases as Array<any>).map(DiscogsSearchArtistsInnerAliasesInnerToJSON)),
        'external_ids': value.externalIds === undefined ? undefined : ((value.externalIds as Array<any>).map(DiscogsSearchArtistsInnerExternalIdsInnerToJSON)),
    };
}

